module.exports = __webpack_public_path__ + "static/media/bgdark.dcf0f2a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bgdark.jpg
// module id = 339
// module chunks = 0